var _rect, _rect2, _rect3, _rect4, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 53 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 27,
    height: 3,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 16,
    width: 27,
    height: 3,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 22,
    width: 27,
    height: 3,
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 28,
    width: 16,
    height: 3,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1837 26.3041C46.7992 25.9076 46.1661 25.8978 45.7696 26.2807L27.9713 43.5365C27.8412 43.6615 27.7479 43.8217 27.701 43.9955L26.0345 50.2514C25.9271 50.6537 26.0795 51.0443 26.3649 51.2807C26.5738 51.4545 26.8539 51.5443 27.1554 51.4974L33.9166 50.4389C34.0382 50.4193 34.1544 50.3783 34.2596 50.3197C34.3314 50.2787 34.3981 50.2279 34.4581 50.1693L52.2274 32.9428C52.6239 32.558 52.6337 31.9252 52.2494 31.5287L47.1837 26.3041ZM31.0353 43.142C30.64 43.5287 30.6322 44.1615 31.0177 44.558L33.6556 47.2611C34.0411 47.6557 34.6742 47.6635 35.0697 47.2787L45.9962 36.6205C46.2301 36.392 46.3285 36.0775 46.2899 35.7767C46.2633 35.5697 46.1713 35.3685 46.0138 35.2064L43.3761 32.5014C43.1805 32.3021 42.9213 32.2006 42.6615 32.2006C42.4093 32.2006 42.1566 32.2943 41.9618 32.4838L31.0353 43.142Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2H40C42.2091 2 44 3.79086 44 6V31H46V6C46 2.68629 43.3137 0 40 0H6C2.68629 0 0 2.68629 0 6V46C0 49.3137 2.68629 52 6 52H27V50H6C3.79086 50 2 48.2091 2 46V6C2 3.79086 3.79086 2 6 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockText);
export default __webpack_public_path__ + "static/media/block_text.76601f09385c7397ed48af1b04c08dae.svg";
export { ForwardRef as ReactComponent };